import LogoutIcon from "@mui/icons-material/Logout";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import Divider from "@mui/material/Divider";
import ListItemIcon from "@mui/material/ListItemIcon";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Typography from "@mui/material/Typography";
import { useNavigate } from "react-router-dom";
import { logout, type TokenClaims } from "../../core/auth/auth";

interface UserMenuProps {
  anchorEl: HTMLElement | null;
  onClose: () => void;
  claims: TokenClaims;
}

const UserMenu = ({ anchorEl, onClose, claims }: UserMenuProps) => {
  const navigate = useNavigate();

  const handleProfile = () => {
    onClose();
    navigate("/profile");
  };

  const handleLogout = async () => {
    onClose();
    await logout();
  };

  return (
    <Menu
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={onClose}
      slotProps={{ paper: { elevation: 2, sx: { minWidth: 200, mt: 1 } } }}
      transformOrigin={{ horizontal: "right", vertical: "top" }}
      anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
    >
      <MenuItem disableRipple disableTouchRipple sx={{ cursor: "default", "&:hover": { bgcolor: "transparent" } }}>
        <Typography variant="body2" fontWeight={600} color="text.primary">
          {claims.name}
        </Typography>
      </MenuItem>
      <Typography variant="caption" color="text.secondary" sx={{ px: 2, pb: 1, display: "block" }}>
        {claims.email}
      </Typography>
      <Divider />
      <MenuItem onClick={handleProfile}>
        <ListItemIcon>
          <PersonOutlineIcon fontSize="small" />
        </ListItemIcon>
        Mi perfil
      </MenuItem>
      <MenuItem onClick={handleLogout}>
        <ListItemIcon>
          <LogoutIcon fontSize="small" />
        </ListItemIcon>
        Cerrar sesión
      </MenuItem>
    </Menu>
  );
};

export default UserMenu;
